"use client";

import Image from "next/image";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import { SanityVideoPlayer } from "@/components/ui/SanityVideoPlayer";
import type { IMentorCard } from "@/sanity/pages/PageMentorTemplate";
import {
  Dialog,
  DialogClose,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "@/shadcn/ui/dialog";
import playIcon from "@/public/mentor/icon-play.svg";

export default function MentorIntroDialog({ mentor, tabIndex }: { mentor: IMentorCard; tabIndex?: number }) {
  const video = mentor.profile?.video;
  if (!video) return null;

  return (
    <Dialog>
      <DialogPrimitive.Trigger tabIndex={tabIndex} className="relative flex min-h-[5.5rem] items-center gap-[1rem] rounded-[0.75rem] border border-white/20 bg-white/[0.09] p-[1.25rem] font-geist text-[1.75rem] font-medium leading-[1.75rem] text-white backdrop-blur-[1.65rem] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#98D8FF]">
        <Image src={playIcon} alt="" className="h-[2rem] w-[2rem]" />
        {mentor.buttonLabel}
      </DialogPrimitive.Trigger>
      <DialogPortal>
        <DialogOverlay className="bg-black/70 motion-reduce:animate-none" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className="fixed top-1/2 left-1/2 z-[999] max-h-[calc(100dvh-4rem)] w-[min(150rem,calc(100%-4rem))] max-w-[calc((100dvh-16rem)*16/9)] -translate-x-1/2 -translate-y-1/2 overflow-y-auto overscroll-contain rounded-[1.5rem] bg-black p-[2rem] text-white outline-none"
        >
          <div className="mb-[2rem] flex items-center justify-between gap-[2rem]">
            <DialogTitle className="font-news text-[3rem]">
              {mentor.name}
            </DialogTitle>
            <DialogClose
              aria-label="Close mentor intro"
              className="flex h-[5.5rem] w-[5.5rem] items-center justify-center rounded-full bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#98D8FF]"
            >
              ×
            </DialogClose>
          </div>
          <div className="aspect-video w-full">
            <SanityVideoPlayer
              playerData={video}
              poster={mentor.portrait?.src}
              autoPlay
              playsinline
              className="h-full w-full"
            />
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
}
